import { useId } from 'react';
import { Icon } from './Icon.tsx';
import { cx } from './util.ts';
import './ConfidenceMeter.css';

export interface ConfidenceMeterProps {
  /** Confianza entre 0 y 1. */
  value: number;
  /** Umbral de la operación: por debajo, el documento va a revisión. */
  threshold?: number;
  label?: string;
  /** Oculta la etiqueta visible (sigue siendo el nombre accesible), p. ej. en tablas. */
  hideLabel?: boolean;
  className?: string;
}

const pct = (n: number) => Math.round(Math.min(1, Math.max(0, n)) * 100);

/** «Confianza 87 %»: barra con valor accesible y marca del umbral si lo hay. */
export function ConfidenceMeter({
  value,
  threshold,
  label = 'Confianza',
  hideLabel = false,
  className,
}: ConfidenceMeterProps) {
  const id = useId();
  const percent = pct(value);
  const below = threshold !== undefined && percent < pct(threshold);
  const valueText = below
    ? `${percent} %, por debajo del umbral del ${pct(threshold)} %`
    : `${percent} %`;

  return (
    <div className={cx('af-confidence', below && 'af-confidence--below', className)}>
      <span id={id} className={cx('af-confidence__label', hideLabel && 'af-sr-only')}>
        {label}
      </span>
      <div
        role="meter"
        aria-labelledby={id}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
        aria-valuetext={valueText}
        className="af-confidence__track"
      >
        <span className="af-confidence__fill" style={{ transform: `scaleX(${percent / 100})` }} />
        {threshold !== undefined && (
          <span className="af-confidence__threshold" style={{ left: `${pct(threshold)}%` }} />
        )}
      </div>
      <span className="af-confidence__value" aria-hidden="true">
        {below && <Icon name="estado-escalado" size="1em" />}
        {percent} %
      </span>
    </div>
  );
}
